


















import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';

@Component
export default class Search extends Vue {
  @Prop() public listView: Components.ListView;
  @Prop({default:null}) public tabs: string;
  @Prop({default:true}) public favoriteVisible: boolean;
  onFavorite(){
    if (this.listView) this.listView.onFavorite();
  }
  onSearch(){
    if (this.listView) this.listView.isSideFilter = false;
  }
  public get title(){
    return this.listView && this.listView.isFavorite ? 'お気に入り更新' : 'お気に入り追加';
  }
}

